import React from "react";
import UserRequests from "./UserRequests.jsx";
import Waitlists from "./Waitlists.jsx";

interface PlayerDashboardProps {
  setDisplay?: (display: string) => void;
}

function PlayerDashboard({ setDisplay }: PlayerDashboardProps) {
  return (
    <>
      <UserRequests />
      <br />
      <br />
      <Waitlists />
      <br />
    </>
  );
}

export default PlayerDashboard;
